var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"avatar avatar-sm rounded-circle"},[_c('avatar',{attrs:{"fullname":_vm.$store.getters['authentication/name'],"size":36,"color":"#172b4d"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }